/** @flow */
import tooltipsTranslations from "./tooltips-translations";

export const recordingMessages = {
  en: {
    INTERACTION_SAVED: "Interaction Saved",
  },
};

export default {
  en: {
    ...tooltipsTranslations.en,
    INCOMING: "Incoming",
    INCOMING_CALL: "Incoming Call",
    WORKING_FIT: "Working Fit",
    SAMARITANS: "Samaritans",
    MEDICINES: "Medicines",
    CALL_INTERACTION: "Call Interaction",
    INCOMING_CALLS_DESCRIPTION:
      "Choose a client organisation and search for an employee record in order to kick off the absence recording process.",
    OUTBOUND: "Outbound",
    OUTBOUND_CALLS_DESCRIPTION:
      "Access the outbound callback queues. Please note that only the queues for which you have permissions will be displayed.",
    RECORDING: "Recording",
    OUR_FIRST_CARE: "OurFirstCare",
    ADDITIONAL_RESOURCES: "Additional Resources",
    CLIENT_INFORMATION: "Client Information",
    ALLOW_TO_REOPEN: "Allow to Re-Open",
    TEXT_TO_CLOSE_ENABLED: "Text to CLose Enabled",
    CONFLUENCE: "Confluence",
    LEARNING_MANAGEMENT: "Learning Management",
    GET_STARTED: "Get Started",
    ACCESS_CALLBACK_QUEUES: "Access Callback Queues",
    CALLBACKS: "Callbacks",
    CALL_PURPOSE: "Call Purpose",
    CONFIRM_DETAILS: "Confirm Details",
    CREATE_ABSENCE: "Create New Absence",
    FINISH_CALL: "Finish Call",
    CONFIRM_ABSENCE_INTERACTION_TYPE: "Interaction Type",
    ABSENCE_INTERACTION: "Absence Interaction",
    ADDITIONAL_INFORMATION_TO_BE_PASSED: "Additional Information to Be Passed On",
    ABSENCE_STATUS: "Absence Status",
    WOULD_YOU_LIKE_TO_KEEP_THE_ABSENCE_OPEN_OR_CLOSE_IT:
      "Would you like to keep the absence open or close it?",
    NEW_EMPLOYEE: "New Employee",
    NOTES: "Notes",
    NURSE_TRANSFER: "Nurse Transfer",
    NURSE_OFFER: "Nurse Offer",
    NURSE_ELIGIBILITY: "Nurse Eligibility",
    REASONS: "Reasons",
    REOPEN_ABSENCE: "Reopen Absence",
    SECURITY_QUESTION: "Security Question",
    SECURITY_ANSWER: "Security Answer",
    CLIENT_MATCH: "Client Match",
    SELECT_CLIENT: "Select Client",
    SELECT_EMPLOYEE: "Select Employee",
    SET_SHIFT_PATTERN: "Shift Pattern",
    UPDATE_ABSENCE: "Update Absence",
    KEEP_ABSENCE_OPEN: "Keep Absence Open",
    WELCOME_SECTION: "Read Welcome Script",
    RESOURCES: "Resources",
    INITIAL_ABSENCE: "Initial Absence",
    MEDICAL_TRIAGE: "Medical Triage",
    DETAILED_ABSENCE: "Detailed Absence",
    ADDITIONAL_QUESTIONS: "Additional Questions",
    END_CALL: "End Call",
    IMPORTANT_NUMBERS: "Important Numbers",
    DUTY_LINE: "Duty Line",
    ADVICE_LINE: "NHS Advice Line",
    NHS_ADVICE: "NHS Advice",
    NHS_SCOTLAND: "NHS Scotland",
    HEAD_OFFICE: "Head Office",
    LAST_NAME: "Last Name",
    FIRST_CARE_HOME: "FistCare Home",
    OPEN_IN_NEW_TAB: "Open in a New tab",
    EMPLOYEE_REF: "Employee Ref",
    CANCEL_INTERACTION: "Cancel Interaction",
    CANCEL_INTERACTION_CONFIRM: "Are you sure you want to cancel this interaction?",
    CANCEL_INTERACTION_CONFIRM_LINE2:
      "This means the absence will remain in place, but your changes to it will be cancelled.",
    NO_KEEP_IT: "No, Keep It",
    YES_CANCEL_INTERACTION: "Yes, Cancel Interaction",

    CREATE_EMPLOYEE_DISABLED:
      "New employee records cannot be created for this client. Please double check that you cannot find their record and, if so, instruct the employee to report their absence to their line manager.",
    WARNING: "Warning",
    PHONE_NUMBER: "Phone Number",
    SEARCH_FOR_EMPLOYEE: "Select Employee",
    ESCALATE: "Escalate",
    INSTRUCTION: "Instruction",
    SCRIPT: "Script",
    TRY_AGAIN: "Try again",
    ABSENCE_CANT_BE_CLOSED: "Absence can't be closed",
    //Client Match
    INACCURATE_MANUAL_SEARCH: "Inaccurate. Manual Search",
    NEXT_SELECT_CLIENT: "Next: Select Client",
    ACCURATE_CONFIRM: "Accurate. Confirm",
    NEXT_CALL_PURPOSE: "Next: Call Purpose",
    //Select Client
    CLIENT_NOT_FOUND: "Client Not Found",
    UNABLE_TO_FIND_CLIENT: "Unable to Find Client",
    UNABLE_TO_FIND_CLIENT_DESC:
      "We are unable to find a client with that name. Are there any alternative names that the organization is known by?",
    UNABLE_TO_FIND_EMPLOYEE: "Unable to Find Employee",
    CALLER_IDENTITY: "Caller Identity",
    MATCHING_EMPLOYEES: "Matching Employees",
    MATCHING_EMPLOYEES_NO_RESULTS: "No records matching selected filters!",
    MATCH: "Match",
    BOTH_DATA_TYPES: "Both Data Types",
    OPEN_EXTENDED_SEARCH: "Open Extended Search",
    SHOW_RECORDS: "Show Records",
    UNABLE_TO_LOCATE_EMPLOYEE: "Unable To Locate Employee",
    CREATE_NEW_EMPLOYEE: "Create New Employee",
    EMPLOYEE_NAME: "Employee Name",
    DEPARTMENT_NAME: "Department Name",
    JOB_TITLE: "Job Title",
    CORRECT: "Correct",
    INCORRECT: "Incorrect",
    INCORRECT_ANSWER: "Incorrect Answer",
    CLOSE_ABSENCE: "Close Absence",
    OPEN_ABSENCE: "Open Absence",
    ABSENCE_ID: "Absence ID",
    REPORTED: "Reported",
    DATE_CLOSED: "Date Closed",
    FIT_AT: "Fit At",
    ERTW: "ERTW",
    REASON: "Reason",
    CONSENT: "Consent",
    SAVE_AND_FINISH: "Save and Finish",
    QUERY: "Query",
    MEDICAL_ADVICE: "Medical Advice",
    SELF: "Self",
    SPOUSE_OR_PARTNER: "Spouse or Partner",
    RELATIVE: "Relative",
    FRIEND: "Friend",
    MANAGER_OR_SUPERVISOR: "Manager or Supervisor",
    HR: "HR",
    COLLEAGUE: "Colleague",
    REASON_AND_DURATION: "Reason & Duration",
    BACK: "Back",
    ABSENCE_START_DATE: "Absence Start Date",
    ABSENCE_TYPE: "Absence Type",
    ABSENCE_REASON: "Absence Reason",
    WAS_THE_ABSENCE_WORK_RELATED: "Was The Absence Work Related",
    WAS_THE_ABSENCE_ACCIDENT_RELATED: "Was The Absence Accident Related",
    ARE_YOU_HAPPY_TO_SHARE_THE_REASON_WITH_THE_EMPLOYER:
      "Are you happy for me to share the reason for your absence with your employer?",
    FIT_DATE: "Fit Date",
    FIT_DATE_AND_TIME: "Fit Date & Time",
    RETURN_TO_WORK_DATE: "Return to Work Date",
    LOG_QUERY: "Log Query",
    LOG_APP_QUERY: "Log App Query",
    UNRESOLVED_QUESRIES_GUIDE: "Unresolved Queries Guide",
    FAQS: "FAQs",
    EMAIL_CAPTURE_PROCESS: "Email Capture Process",
    EMPLOYER_NAME: "Employer Name",
    ABSENCE_CONTACT_PHONE_NUMBER:
      "Can I confirm the following telephone number is the best number to contact you on, which could include a text message or Nurse call-back.",
    NO_EXISTING_PHONE_NUMBER: "No existing phone number",
    ABSENCE_DETAILS_PHONE_LABEL: "Phone Number for GoodShape to contact you if required?",
    ABSENCE_START_AT_LABEL: "Absence Starts At",
    MEDICAL: "Medical Only",
    NON_MEDICAL: "Non-Medical Only",
    APPOINTMENT: "Appointment",
    ABSENCE_STARTS_AT: "Absence Starts",
    CONTACT_NUMBER: "Contact Number",
    REASON_FOR_UPDATE: "Reason For Update",
    FIT_NOTE_EXTENSION: "Fit note extension",
    SYMPTOMS_PERSIST: "Haven't recovered from symptoms",
    NOT_DISCLOSED: "Not Disclosed",
    CONTEST_GIVEN: "Contest Given",
    GENERAL_REASON: "General Reason",
    OUTBOUND_CALLBACKS: "Outbound Callbacks",
    CALLBACK_TYPE_AUTO: "Auto Callbacks",
    CALLBACK_TYPE_ASAP: "ASAP Callbacks",
    ASAP_CALLBACKS_SLA: "ASAP Callbacks SLA %",
    ASAP_SLA: "ASAP SLA %",
    CALLBACK_TYPE_SCHEDULED: "Scheduled Callbacks",
    CALLBACK_TYPE_SCHEDULED_SLA: "Scheduled Callbacks SLA %",
    CALLBACK_TYPE_MEDICAL_ADVICE: "Medical Advice Callbacks",
    INSIDE_SLA: "Inside SLA",
    OUTSIDE_SLA: "Outside SLA",
    SELECT_CALLBACK_TYPE_AUTO: "Select Auto",
    SELECT_CALLBACK_TYPE_ASAP: "Select ASAP",
    SELECT_CALLBACK_TYPE_SCHEDULED: "Select Scheduled",
    SELECT_CALLBACK_TYPE_MEDICAL_ADVICE: "Select Medical",
    CALLBACK_ATTEMPT: "Callback Attempt",
    CALLBACK_REASON_FAILED: "Failed Reason",
    SEND_INVITE: "Send Invite",
    CALLBACK_REASON_REMOVED: "Removed Reason",
    THIRD_PARTY_ANSWERED: "Third party answered",
    ENGAGED: "Engaged",
    RUNG_OUT: "Rung out",
    INCORRECT_PHONE_NUMBER: "Incorrect phone number",
    CANCELLED: "Cancelled",
    EMPLOYEE_NO_LONGER_WANTS_ADVICE: "Employee no longer needs advice",
    INCORRECT_NUMBER: "Incorrect phone number",
    PHONE_SWITCHED_OFF: "Phone switched off",
    EMPLOYEE_REQUEST: "Employee request",
    RTW_AT: "RTW Date",
    CALLBACK_INSTRUCTION: "Callback Instruction",
    CALLBACK_SCRIPT: "Callback Script",
    CONTACT_PHONE_NUMBER_IS_REQUIRED: "Contact Phone Number is Required!",
    SELECT_ABSENCE_TO_REOPEN: "Select Absence to Reopen",
    NEXT_INTERACTION_NOTES: "Next: Interaction Notes",
    VIEW_EMPLOYEE_RECORD: "View Employee Record",
    EMPLOYEE_PROFILE: "Employee Profile",
    NO_CLIENT_SELECTED_YET: "No client selected yet.",
    MEDICAL_INFORMATION_IS_NOT_AVAILABLE: "Medical Information not available for viewing",
    NEXT_CONFIRM_DETAILS: "Next: Confirm Details",
    EMPLOYEE_AND_ABSENCE_DETAILS: "Employee and Absence Details",
    //Medical Triage
    ASSESSMENT_CONSENT: "Medical History Assessment Consent",
    PAST_MEDICAL_HISTORY: "Past Medical History",
    CURRENT_MEDICATIONS: "Current Medications",
    GOODSHAPE_APP: "Goodshape App",
    APP_ENABLED: "App Enabled",
    ONBOARDERD_TO_APP: "Onboarded to App",
    CURRENT_ALLERGIES: "Current Allergies",
    ASSESSMENT: "Assessment",
    LOG_YOUR_ADVICE_NOTES: "Log Your Advice Notes",
    //0 Assessment Consent Script
    ASSESSMENT_CONSENT_SCRIPT:
      "I would like to take you through a series of question’s relating to your symptoms and medical history in order to support an assessment to give you advice. The information you give for this assessment is confidential. Are you happy to proceed?",
    SKIP_ASSESSMENT: "No, Skip Assessment",
    PROCEED_ASSESSMENT: "Yes, Proceed",
    WARNING_ASSESSMENT_CONSENT_SCRIPT:
      "Please note that, as you have not given your consent to go through triage I will not be able to give you any medical advice on this occasion. If you have any concerns about your health please contact your GP or local hospital as soon as you can.",
    NEXT_OUTCOME: "Next: Outcome",
    NEXT_CLASSIFICATION: "Next: Classification",
    NEXT_6_6: "Next: {nextScreen}",
    //1. Past Medical History
    DO_YOU_SMOKE: "Do you smoke?",
    SMOKE: "Smoke",
    DONT_SMOKE: "Don't Smoke",
    HOW_MANY_CIGARETTES_A_WEEK: "Cigarettes/Vaping per day",
    DO_YOU_DRINK: "Do you drink?",
    DRINK: "Drink",
    DONT_DRINK: "Don't Drink",
    HOW_MANY_UNITS_A_WEEK: "How many units a week do you drink?",
    CONFIRM_PAST_MEDICAL_HISTORY: "Confirm Past Medical History",
    SELECT_TYPE: "-- Select Type --",
    CONDITION: "Condition",
    TREATMENT: "Treatment",
    SELECT_CONDITION: "-- Select Condition --",
    SELECT_TREATMENT: "-- Select Treatment --",
    SELECT_TREATMENT_AND_CONDITION: "-- Select Condition and Treatments --",
    ADD_RECORD: "Add Record",
    NEXT_CURRENT_MEDICATIONS: "Next: Current Medications",
    //2. Current Medications
    CONFIRM_MEDICATIONS: "Confirm Medications",
    SELECT_MEDICATION: "-- Select Medication --",
    SELECT_STATUS: "-- Select Status --",
    NEXT_CURRENT_ALLERGIES: "Next: Current Allergies",
    //3. Current Allergies
    CONFIRM_ALLERGIES: "Confirm Allergies",
    SELECT_ALLERGY: "-- Select Allergy --",
    NEXT_ASSESSMENT: "Next: Assessment",
    //4. Assessment
    SELECT_FROM_TRIAGE_SYMPTOMPS: "Select from Symptoms",
    NO_RELEVANT_TRIAGE_SYMPTOM: "No Relevant Symptom",
    NO_RELEVANT_TEXT:
      "There are no set RF questions to cover these symptoms, however you are still accountable for a full triage assessment with the apropriate evidence-based questions, for guidance please use NHS Choices",
    SELECTED_SYMPTOMS: "Selected Symptoms",
    SELECT_SYMPTOM: "-- Select Symptom --",
    ASSESSMENT_OUTCOME: "Assessment Outcome",
    TOTAL_SYMPTOMS: "Symptoms",
    TOTAL_QUESTIONS: "Questions",
    GET_OUTCOME: "Get Outcome",
    COMPLETE_ALL_QUESTIONS: "Please complete all questions above",
    OVERRIDE_OUTCOME_WITH: "Override Outcome with",
    REASON_FOR_OVERRIDE: "Reason for Override",
    NEXT_ADVICE: "Next: Advice",
    SELECT_OVERRIDE_OUTCOME: "-- Select Outcome --",
    SELECT_REASON: "-- Select Reason for Override --",
    ONE_ONE_ONE: "Call 111",
    NINE_NINE_NINE_OR_A_AND_E: "Call 999 or A&E",
    CONTINUE_CURR_TREATMENT: "Continue Current Treatment",
    A_AND_E_OR_WIC: "A&E or WIC",
    GP_VISIT: "GP Visit",
    DENTIST: "Dentist",
    NINE_NINE_NINE: "Call 999",
    SELF_CARE: "Self Care",
    ALREADY_UNDER_GP: "Already under the care of GP or specialist",
    OTHER: "Other",
    REFERRAL_TO_111_MORE_APPROPRIATE: "Referral to 111 is more appropriate",
    REFERRAL_TO_GP_OR_WIC_MORE_APPROPRIATE: "Referral to GP/WIC is more appropriate",
    REFERRAL_TO_DENTIST_MORE_APPROPRIATE: "Referral to dentist is more appropriate",
    REFERRAL_TO_PHARMACIST_MORE_APPROPRIATE: "Referral to pharmacist is more appropriate",
    SELF_MANAGEMENT_MORE_APPROPRIATE: "Self-management is more appropriate",
    PREVENT_CROSS_INFECTION: "To prevent cross infection",
    //5. Advice
    ADVICE: "Advice",
    SYMPTOM_ADVICE: "Symptom Advice",
    OTHER_SYMPTOMS: "Other Symptoms",
    ADDITIONAL_SYMPTOM: "Additional Symptom",
    DESCRIBE_SYMPTOM: "Describe Symptom",
    ENTER_YOUR_NOTES: "Enter Your Notes here",
    ADD_SYMPTOM: "Add Symptom",
    LIFESTYLE_ADVICE: "Lifestyle Advice",
    WORSENING_ADVICE: "Worsening Advice",
    VIEW_GUIDANCE_NOTES: "View Guidance Notes",
    WORSENING_ADVICE_SCRIPT:
      "If you notice that your symptoms persist, get worse or you are concerned I would advise seeking further medical attention, e.g contacting your GP, 111 or A and E*",
    WORSENING_ADVICE_CONFIRM:
      "Please confirm that you have relayed the message above to the employee regarding Worsening Advice",
    AREA: "Area",
    ENTER_YOUR_NOTES_HERE: "Enter Your Notes here",
    ALCOHOL: "Alcohol",
    DIET_NUTRITION: "Diet nutrition",
    SUPPLEMENTAL_NOTES: "Supplemental Notes",
    SYMPTOM: "Symptom",
    EXERCISE: "Excercise",
    SLEEP: "Sleep",
    SMOKING: "Smoking",
    PATIENT_LEAFLET_ADVICE_CONFIRM:
      "Please read the Patient Information Leaflet for all medications that you take",
    //6 Classification
    CLASSIFICATION: "Classification",
    IS_WORK_RELATED: "Is the absence work related?",
    IS_ACCIDENT_RELATED: "Is the absence accident related?",
    HAS_CONSENT_TO_SHARE:
      "Are you happy for me to share the reason for your absence with your employer?",
    AGREE_FIT_RETURN_TO_WORK_DAYS: "Agree Estimated Fit Return to Work Dates",
    FIT_AS_SUGGESTED: "Fit Date Suggested to Employee:",
    DID_EMPLOYEE_AGREED_TO_THE_SUGGESTED_DATE: "Did the employee agreed to the suggested date?",
    FIT_AS_AGREED: "Fit Date Agreed with Employee",
    DISCUSSION_TYPE: "Discussion Type",
    DID_THE_EMPLOYEE_AGREED_SUGGESTED_DATE: "Did the employee agreed to the suggested date?",
    WORK_RELATED: "Work",
    NON_WORK_RELATED: "Non-Work",
    ACCIDENT_RELATED: "Accident Related",
    NON_ACCIDENT_RELATED: "Non-Accident",
    CAN_I_HAVE_YOUR_CONSENT_TO_DISCLOSE:
      "Can I have your consent to disclose that reason to your employer?",

    //6A. Outcome
    NEXT_FINISH: "Next: Finish",
    OPEN_NEW_ABSENCE: "Open New Absence",
    RAISE_QUERY: "Raise Query",
    INTERACTION_ITEMS: "Interaction Items",
    PHONE_LINE_QUALITY: "Phone Line Quality",
    INTERACTION_NOTES: "Interaction Notes",
    INTERACTION_NOTES_OPTIONAL: "Your Internal Interaction Notes (Optional)",
    INTERACTION_NOTES_PLACEHOLDER: "My notes here.",
    LOG_YOUR_INTERACTION_NOTES: "Log Your Interaction Notes",
    FINISH_AND_OPEN_NEW_ABSENCE: "Finish and Open New Absence",
    FINISH: "Finish",
    COMPLETE_CALL: "Complete call",
    FOUND_SHIFT_PATTERN_FOR_USER: "Found Shift Patterns for {user}",
    NO_SHIFT_PATTERN_FOUND_FOR_USER: "No Shift Pattern found for {user}. Manual Entry Required.",
    NO_SHIFT_PATTERNS_FOUND: "No Shift Patterns found.",
    FOUND_SHFT_PATTERNS_ANSWER: "Found Shift Patterns {answer}",
    ACCURATE: "Accurate",
    INACCURATE: "Inaccurate",
    THIS_IS_CORRECT: "This is Correct",
    ORGANIZATIONAL_UNIT: "Organizational Unit",
    ASSIGNED_PATTERN: "Assigned Pattern",
    NEXT_REASON_AND_DURATION: "Next: Reason and Duration",
    NEXT_ADDITIONAL_QUESTIONS: "Next: Additional Questions",
    SHIFT_PATTERN: "Shift Pattern",
    SELECT_SHIFT_PATTERN_TO_LOAD: "Select Shift Pattern to Load",
    LOADED_PATTERN_NAME: "Loaded Shift Pattern {name}",
    CREATE_SHIFT_PATTERN: "Create Shift Pattern",
    HOURS_LOST_VALUE: "Hours Lost: {value}",
    DAYS_LOST_VALUE: "Days Lost: {value}",
    LOAD_SHIFT_PATTERN: "Load",
    SET_CALLBACK: "Set Callback",
    TRIAGE: "Triage",
    CONTACT_PHONE_NUMBER: "Contact Phone Number",
    NEXT_FINISH_CALL: "Next: Finish Call",
    NEXT_FIND_SELECT_EMPLOYEE: "Next: Find and Select Employee",
    INELIGIBLE_CLOSE_REQUEST: "Ineligible Close Request",
    NO_UPDATE: "No Update",
    UPDATE_ABSENCE_DETAILS: "Initial Absence Details",
    NEXT_SHIFT_PATTERN: "Next: Shift Pattern",
    REPEAT_SHIFT_PATTERN: "Repeat First 7 Days",
    REPEAT_SHIFT_PATTERN_DAYS: "{days} Days",
    ARE_YOU_HAPPY_TO_SHARE_YOUR_ABSENCE_REASON:
      "Are you happy for me to share the reason for your absence with your employer?",
    OK_TO_SHARE: "OK to Share",
    NOT_OK_TO_SHARE: "Not OK to Share",
    NOT_PROVIDED_TITLE: "Not Provided {title}",
    DECLINE_CALLBACK: "Decline Callback",
    ACCEPT_CALLBACK: "Accept Callback",
    DECLINE_REFERRAL: "Decline Referral",
    ACCEPT_REFERRAL: "Accept Referral",
    REFERRAL_DECLINED: "Referral Declined",
    REFERRAL_ACCEPTED: "Referral Accepted",
    NURSE_TRANSFER_DECISION: "Nurse Transfer",
    NURSE_OFFER_DECISION: "Nurse Offer",
    CALLBACK_DECLINED: "Callback Declined",
    REASON_FOR_DECLINE: "Reason for Decline",
    CANCEL_TRANSFER: "Cancel Transfer",
    TRANSFER_EMPLOYEE: "Transfer Employee",
    DOB: "DOB",
    TYPE_TO_SEARCH_NURSES: "Type to Search Nurses",
    THERE_WAS_NO_RESPONSE: "There was no response",
    CHANGE_NURSE: "Change Nurse",
    ACCEPT_TRANSFER_DESCRIPTION:
      "If an absence advisor is in the process of transferring a call to you, click the button below to accept the employee's record",
    SELECT_SIGNPOSTED_TO: "Please select Signposted To outcome",

    ABSENCE_STATUS_DESCRIPTION_OPEN_WITH_RTW:
      '{name} has an <b class="text-orange">Open</b> {absenceType} absence with a Return to Work Date of <b class="text-orange">{date}</b>.',
    ABSENCE_STATUS_DESCRIPTION_OPEN_NO_RTW:
      '{name} has an <b class="text-orange">Open</b> {absenceType} absence with no Return to Work Date set.',
    ABSENCE_STATUS_DESCRIPTION_NOT_OPEN: "{name} does not have a current open absence.",

    ABSENCE_CANT_BE_CLOSED_INFO:
      '<b class="text-orange">{firstName}</b> is not currently eligible to close their absence.',

    CONFIRM_DETAILS_HELP_MESSAGE:
      'If any details are incorrect please return to the <b class="text-orange">Reason and Duration</b> step.',

    NOT_OVERDUE_TEXT: "The next Scheduled Callback is not due until: ",
    NOT_OVERDUE_TEXT_2: "The details of the callback will be...",

    ADDITIONAL_QUESTION_INFO:
      "Is there any additional information you would like me to pass on to your employer?",
    ABSENCE_ID_ABSENCE_ID_ADVISOR_INTERACTIONS: "Absence ID: {absenceId} Advisor Interactions",
    ABSENCE_INTERACTIONS: "Absence Interactions",
    REFERRAL_QUESTIONS_LONG_TEXT:
      "I would like to refer you to our healthcare partner, <strong>{SUPPLIER_NAME}</strong>, who can provide additional, confidential, advice to facilitate your recovery and return to work. Unless you have any objections, I would like to provide them with your contact details so that they can call you directly to discuss how best to support you. Is that ok?",
    MANAGER_REFERRAL_QUESTION_LONG_TEXT:
      "This employee’s absence has met the criteria for a referral to <strong>{SUPPLIER_NAME}</strong> a <strong>{SUPPLIER_DESCRIPTION}</strong> who can provide the employee with advice and support to facilitate their recovery and return to work. Do you wish to refer this employee to <strong>{SUPPLIER_NAME}</strong>?",
    VACCINATIONS: "Vaccinations",
    VACCINATION: "Vaccination",
    DATE_VACCINATED: "Date Vaccinated",
    ASSESSMENT_ONE_ONE_ONE: "111",
    ASSESSMENT_NINE_NINE_NINE_OR_A_AND_E: "999/A&E",
    ASSESSMENT_DENTIST: "Dentist",
    ASSESSMENT_GP: "GP",
    ASSESSMENT_CONTINUE_CURR_TREATMENT: "Continue Current Treatment",
    ASSESSMENT_SELF_CARE: "Self Care",
    ASSESSMENT_WIC: "WIC",
    ASSESSMENT_ALREADY_UNDER_GP: "Already under the care of GP or specialist",
    ASSESSMENT_OTHER: "Other",
    ASSESSMENT_REFERRAL_TO_111_MORE_APPROPRIATE: "Referral to 111 is more appropriate",
    ASSESSMENT_REFERRAL_TO_GP_OR_WIC_MORE_APPROPRIATE: "Referral to GP/WIC is more appropriate",
    ASSESSMENT_REFERRAL_TO_DENTIST_MORE_APPROPRIATE: "Referral to dentist is more appropriate",
    ASSESSMENT_REFERRAL_TO_PHARMACIST_MORE_APPROPRIATE:
      "Referral to pharmacist is more appropriate",
    ASSESSMENT_SELF_MANAGEMENT_MORE_APPROPRIATE: "Self-management is more appropriate",
    SETTING_THE_SCENE: "Setting The Scene",
    FIT_RTW_DATE_VALIDATION_MSG: "RTW Date should be after Fit Date",
    CONSENT_TO_SHARE_QUESTION: "Consent to share absence reason with employer?",
    WORK_RELATED_QUESTION: "Work related?",
    ACCIDENT_RELATED_QUESTION: "Accident related?",
    SIGNPOSTED_TO: "Signposted to:",
    USER_ACCOUNT: "User Account",
    BOOK_CALLBACK: "Book Scheduled Callback",
    BANK_HOLIDAY_ABSENCES: "Bank Holiday Absences",
    REOPENING_ABSENCES: "Re-Opening Absences",
    CLOSING_IN_ADVANCE: "Closing in Advance",
    BOOK_CALLBACK_DESCRIPTION:
      "Use this button to book a scheduled callback between the employee and a GoodShape nurse for a specific time of day.",
    CORRECT_CLIENT: "Correct Client",
    INCORRECT_CLIENT: "Incorrect Client",
    SEE_MORE: "SEE MORE",

    CLOSE_AN_ABSENCE: "Close Absence",
    CLOSE_ABSENCE_WARNING: "Are you sure you want to close the absence for employee {name}?",
    CONFIRM_ABSENCE_CLOSE: "Yes, Close Absence",
    ABSENCE_DETAILS_CONFIRMATION_WARNING:
      "I have confirmed all the above details are correct with the employee",
    ABSENCE_OVERLAP_WARNING: "An absence already exists for a similar date: {startsAt} – {rtwAt}",
    RECORD_DETAILS: "Record Details",
    USER_ACCOUNT_INFORMATION:
      "Personal Email Address: The Email Address can be used to allow the employee to login into GoodShape’s web services, and to receive communications necessary for the secure management of their account, and ongoing support for their absences. The email address will be visible on their record for their employer to see.",
    TRIAGE_ID: "Triage ID: {id}",
    RED_FLAGS: "Red Flags",
    ANSWER: "Answer",
    ADVICE_GIVEN: "Advice Given",
    TRIAGE_HISTORY: "Triage History (Last 3 Years)",
    NURSE: "Nurse",
    DUTIES: "Duties",
    JOB_DUTIES: "Job Duties",
    HOW_TO_ACCESS_THE_SERVICE: "How to Access the Service",
    WEBSITE: "Website",
    USER_NAME: "User Name",
    SERVICE_INFORMATION: "Service Information",
    WORKING_LOCATION: "Working Location",
    EMPLOYEES_CURRENT_LOCATION: "The employee’s current working location:",
    TRIAGES: "Triages",
    NO_ADVICE_RESULTS: "There are no symptom specific advice details recorded for this triage.",
    NO_LOCATION_RESULTS: "Employee's working location not recorded.",
    NO_DUTIES_RESULTS: "This employee has not shared their job duties.",
  },
};
